export const FULL_INSPECTION = 'Y';
export const PHOTOS_AND_BASIC = 'B';
export const PHOTO_ONLY = 'P';
export const YARD_INSPECTION = 'R';
export const UNINSPECTED = 'N';

export enum assetInspectionTypeName {
  Y = 'Full',
  B = 'Photos and Basic',
  P = 'Photo Only',
  R = 'DEI Inspection',
  N = 'None'
}

export const ipAssetInspectionTypes = [
  {
    code: FULL_INSPECTION,
    name: assetInspectionTypeName[FULL_INSPECTION]
  },
  {
    code: PHOTOS_AND_BASIC,
    name: assetInspectionTypeName[PHOTOS_AND_BASIC]
  },
  {
    code: PHOTO_ONLY,
    name: assetInspectionTypeName[PHOTO_ONLY]
  },
  {
    code: UNINSPECTED,
    name: assetInspectionTypeName[UNINSPECTED]
  }
];

export const rbAssetInspectionTypes = [
  {
    code: FULL_INSPECTION,
    name: assetInspectionTypeName[FULL_INSPECTION]
  },
  {
    code: PHOTOS_AND_BASIC,
    name: assetInspectionTypeName[PHOTOS_AND_BASIC]
  },
  {
    code: PHOTO_ONLY,
    name: assetInspectionTypeName[PHOTO_ONLY]
  },
  {
    code: YARD_INSPECTION,
    name: assetInspectionTypeName[YARD_INSPECTION]
  }
];
